module.exports = __webpack_public_path__ + "img/dropdown.4c3e248b.svg";